export const formatCurrency = (amount, currency = 'NGN') =>
  new Intl.NumberFormat('en-NG', { style: 'currency', currency }).format(amount);

export const formatDate = (date) =>
  date ? new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(date)) : '—';

export const formatDateTime = (date) =>
  date ? new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(date)) : '—';

export const getLoanStatusClass = (status) => {
  const map = {
    active: 'badge-success', approved: 'badge-success', disbursed: 'badge-success', closed: 'badge-gray',
    submitted: 'badge-info', under_review: 'badge-info', credit_check: 'badge-info', offer_sent: 'badge-info',
    offer_accepted: 'badge-success', rejected: 'badge-danger', defaulted: 'badge-danger',
    draft: 'badge-gray', offer_declined: 'badge-warning',
  };
  return map[status] || 'badge-gray';
};

export const getKYCStatusClass = (status) => {
  const map = { approved: 'badge-success', pending: 'badge-warning', under_review: 'badge-info', rejected: 'badge-danger', resubmit: 'badge-warning', not_submitted: 'badge-gray' };
  return map[status] || 'badge-gray';
};

export const getContributionStatusClass = (status) => {
  const map = {
    active: 'badge-success', completed: 'badge-success', paid: 'badge-success',
    pending: 'badge-info', partial: 'badge-warning', overdue: 'badge-warning',
    advanced: 'badge-info', missed: 'badge-danger', cancelled: 'badge-gray', waived: 'badge-gray',
  };
  return map[status] || 'badge-gray';
};

export const getGroupStatusClass = (status) => {
  const map = {
    forming: 'badge-info', active: 'badge-success', completed: 'badge-success',
    cancelled: 'badge-gray', ready: 'badge-success', collecting: 'badge-info',
    released: 'badge-success', short: 'badge-warning', skipped: 'badge-gray',
  };
  return map[status] || 'badge-gray';
};

export const humanizeStatus = (status) =>
  status ? status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '—';
